import { FaUsers } from "react-icons/fa";

const StepsSection = () => {
  const steps = [
    {
      id: 4,
      title: "Continuous Improvement",
      description: "We monitor performance and make necessary adjustments to optimize outcomes, ensuring that your business stays competitive and continues to grow.",
    },
    {
      id: 3,
      title: "Implementing with Precision",
      description: "We execute the strategy with a focused approach, ensuring that every element aligns with your business objectives and delivers measurable results.",
    },
    {
      id: 2,
      title: "Crafting Tailored Solutions",
      description: "Our team of professionals designs innovative and scalable solutions tailored to your specific business requirements, ensuring long-term success.",
    },
    {
      id: 1,
      title: "Understanding Your Goals",
      description:
        " We begin by listening carefully to your business needs, challenges, and aspirations to understand the bigger picture and align our strategies accordingly.",
    },
    
   
  ];

  return (
    <div
      className="relative small:bg-[100% 100%] bg-contain"
      style={{
        backgroundImage: "url('/process.png')",
        backgroundSize: "100% 100%",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-red-50 to-white opacity-80"></div>

      <div className="max-w-[1280px] mx-auto md:px-10 px-5 md:py-10 py-5 text-center relative small:h-[650px] ">
        <h3 className="text-lg text-primary font-medium">/ Why Choose Us /</h3>
        <h2 className="md:text-4xl small:text-3xl text-2xl font-semibold text-secondary mt-2">
          Our Team of Experts is <br /> Ready to Assist You
        </h2>

        <div className="relative small:grid-cols-4 xs:grid-cols-2 grid-cols-1 gap-5 grid mt-8 w-full h-full">
          {steps.map((step, index) => {
            // Positioning based on the index
            const positions = [
              { right: "top-0 right-0" },
              { right: "top-[12%] right-[20%]" },
              { right: "top-[24%] right-[40%]" },
              { right: "top-[40%] right-[65%]" },
            ];

            return (
              <div
                key={step.id}
                className={`group small:!w-[400px] !w-full small:absolute ${positions[index].right} flex flex-col items-center text-center  rounded-lg transition duration-300 ease-in-out `}
              >
                <div className="relative w-16 h-16 flex items-center justify-center rounded-full bg-transparent transition duration-300 group-hover:bg-secondary">
                  {/* Default Image */}
                  <img
                    src={require("../../common/images/three-man.png")}
                    alt="Step Icon"
                    className="size-12 absolute transition duration-300 group-hover:opacity-0"
                  />

                  {/* Hover Image */}
                  <img
                    src={require("../../common/images/white-three-man.png")}
                    alt="Step Icon Hover"
                    className="size-12 absolute opacity-0 transition duration-300 group-hover:opacity-100"
                  />
                </div>

                {/* Step Title */}
                <h3 className="text-md font-semibold text-secondary">
                  {step.title}
                </h3>

                {/* Step Description */}
                <p className="text-gray-600 mt-2 text-[12px] max-w-[220px]">
                  {step.description}
                </p>

                {/* Step Number with background hover effect */}
                <div className="mt-4 px-4 py-1 rounded-md  transition duration-300 group-hover:bg-secondary">
                  <span className="text-sm text-webOranage font-medium transition duration-300 group-hover:text-white">
                    Step {step.id}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StepsSection;
